import {
  LocalStorageKey,
  useLocalStorageValue,
} from "./useLocalStorageValue.ts";
import { useHomeContextUser } from "../../routes/home/homeContext.ts";
import { hash } from "../utils/string.ts";
import { useMemo } from "react";

export enum FractionPersistKey {
  SubscriptionPopoverStatus = "subscription-popover-status",
}

type FullPersistObject = Record<string, { value: unknown; expires: boolean }>;

/**
 * This is used to interoperate with fraction local storage values
 * stored under the "persist" key
 */
export default function useFractionPersistValue<T>(
  keySuffix: FractionPersistKey
): [T | undefined, (val: T) => void] {
  const user = useHomeContextUser();
  const [fullPersistObj, updateValue] = useLocalStorageValue<FullPersistObject>(
    LocalStorageKey.FractionPersist
  );

  const userKey = `${hash(user.email)}__${keySuffix}`;

  return useMemo(
    () => [
      fullPersistObj?.[userKey]?.value as T | undefined,
      (newValue: T) => {
        updateValue({
          ...fullPersistObj,
          [userKey]: { value: newValue, expires: false },
        });
      },
    ],
    [fullPersistObj, userKey, updateValue]
  );
}
